// Text for contents should only be blue (linked) for logged-in users with a subscription.  
//These will open the PDF.For logged- out / non - subscribers, the TOC text is not linked. (wireframe is incorrect)
import React, { Component } from 'react';
import '../../../src/styles/Manual.css';
import { Link } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal'
import { Button } from 'react-bootstrap';
import ChapterModal from 'react-bootstrap/Modal'
import queryString from 'query-string';
import { appService } from '../../_services';
import { authHeader, config } from '../../_helpers';
import DocumentMeta from 'react-document-meta';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import ShoppingcartModal from 'react-bootstrap/Modal';
import { Redirect, Route } from 'react-router-dom';
import * as axios from 'axios';
import EmailModal from 'react-bootstrap/Modal';
import { Page } from 'react-pdf';
import { Document } from 'react-pdf/dist/entry.webpack';
import { Maintenance } from '../Maintenance/Maintenance.jsx';
import ReactGA from 'react-ga';
var fileName = "";
var paddingsetforwhite = {
    paddingTop: '1.5%',
    paddingLeft: '0.5%',
    paddingRight: '0.5%'
}
var paddingsetforgrey = {
    paddingTop: '1%'
}

var sectionStyle = {
    height: "39px",
};
var sectionTopicStyle = {
    height: "30px"
};

var setpdfpadding = {
    paddingLeft: '45px'
}
var Displaystyle = {
    display: 'inline-block'
}

var Fright = {
    float: 'right'
}

var paddset = {
    marginLeft: '45%'
}

let useragent = navigator.userAgent;
let url = '', params = '', parameters = '', AllauthorNames = '', authorFullName = '', productDetailId = '', authors = '', Emailparameters = "", PubDate = '';
let meta = '', authorNames = '', monthNames = '', renderSamplePDF = '';
let DipslayExtractPdf = '';
export class ManualChapter extends Component {
    displayName = ManualChapter.name
    constructor(props) {
        super(props);
        this.state = { //this is a temporary fix for hiding/showing links if not logged in -  condition will be modified 
            login: false, Subscribed: false,
            ChapterTitle: '',
            Extract: '',
            ChapterId: '',
            Imgurl: '',
            Isfree: false,
            IsSample: '',
            Title: '',
            Authors: '',
            nextid: '',
            previd: '', Publishedyear: '', PublicationMon: '', Reviewedyear: '', ReviewedMon: '',
            countryName: '',
            OnlinePrice: '',
            printedmaterial: '',
            PdfPrice: '',
            user: '', newcurrency: '',
            samplePDF: [],
            redirectToSearch: false,
            redirectToLogin: false,
            searchAuthor: "",
            IsPreface: false,
            IsGeneralSection : false
        }
        this.state = {
            email: 'dawn.danish@wolterskluwer.com',
        };
        this.state = {
            checked: false,
            checked1: true,
            Contents: [],
            pageBookMarkList: [],
            productprice: [],
            link: '',numPages: null,
            pageNumber: 1,
            emailReciepient: '', //Start:Pradip Lalvani -New
            PDFData: '', mainEditors: '', TopicId: '', TopicName: '', emailRec: '', emailName: '', IsError: false,
            redirectToLogin: false

        };
        this.onChange = this.onChange.bind(this);
        this.onChange1 = this.onChange1.bind(this);

        this.handleSelect = this.handleSelect.bind(this);
        //this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleChapterModalShow = this.handleChapterModalShow.bind(this);
        this.handleChapterModalClose = this.handleChapterModalClose.bind(this);
        this.handleChapterBuyModalShow = this.handleChapterBuyModalShow.bind(this);
        this.sendEmail = this.sendEmail.bind(this);
        this.handleModalShow = this.handleModalShow.bind(this);
        this.handleModalClose = this.handleModalClose.bind(this);
        this.handleValidation = this.handleValidation.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.searchAuthorContent = this.searchAuthorContent.bind(this);
        this.handleEmailModalShow = this.handleEmailModalShow.bind(this);
        this.handleEmailModalClose = this.handleEmailModalClose.bind(this);
        this.sendShareByEmail = this.sendShareByEmail.bind(this)
        this.handleEmailValidation = this.handleEmailValidation.bind(this)
        this.logoutsession = this.logoutsession.bind(this);
        this.handleEtocModalShow = this.handleEtocModalShow.bind(this);
        this.handleEtocModalClose = this.handleEtocModalClose.bind(this);
    }
    handleEtocModalClose() {
        this.setState({ handleEtocModalShow: false });
    }

    handleEtocModalShow() {
        this.setState({ handleEtocModalShow: true });
    }
    logoutsession() {

        var self = this;
        if (localStorage.getItem('user') !== null) {
            appService.getAll('/User/logOutDecreseActiveCount').then(function (response) {
                appService.getAll('/User/logOut').then(function (response) {

                    //localStorage.removeItem('user');
                    //localStorage.removeItem('userId');
                    //localStorage.removeItem('usersubscription');
                    //localStorage.removeItem('company');
                    //localStorage.removeItem('firstName');
                    //localStorage.removeItem('lastName');
                    //localStorage.removeItem('salesForceID');
                    localStorage.clear();
                    localStorage.setItem('logoutclick', 'true');

                });
                window['LastURL'] = '';
            });

        }
        self.setState({
            redirectToLogin: true
        })
    }
    handleEmailValidation() {
        var self = this;
        let fields = self.state.fields;
        let errors = {};
        let formIsValid = true;

        var emailTo = this.refs["email"].value;

        if (emailTo == "") {
            formIsValid = false;
            this.state.emailRec = "* Required field";
        }

        if (emailTo != "") {
            var emails = emailTo.split(";");
            emails.forEach(function (emails) {
                let lastAtPos = emails.lastIndexOf('@');
                let lastDotPos = emails.lastIndexOf('.');

                if (!(lastAtPos < lastDotPos && lastAtPos > 0 && emails.indexOf('@@') == -1 && lastDotPos > 2 && (emails.length - lastDotPos) > 2)) {
                    formIsValid = false;
                    self.state.emailRec = "* Please enter a valid email address";
                }
            })
        }
        self.setState({ errors: errors });

        return formIsValid;

    }

    sendShareByEmail() {
        if (this.handleEmailValidation()) {
            this.state.emailRec = '';
            Emailparameters = {
                Email: this.refs["email"].value,
                Subject: this.refs["SubjectTitle"].value == "" ? this.state.Title : this.refs["SubjectTitle"].value,
                Category: window.location.href,
                AdditionalInfo: this.refs["AddInfo"].value
            }
            var self = this;
            appService.submit('/Email/ShareByEmail', Emailparameters)
                .then(function (data) {
                    if (data == "Success") {
                        self.setState({ handleEmailModalShow: false });
                    }
                });
        }
    }

    decodeHtml(html) {
        var txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    }

    stingBreakLine(str, length, ending) {
        //console.log(str.length);
        if (length == null) {
            length = 68;
        }
        if (ending == null) {
            ending = '..';
        }

        if (str != null && str.length > length) {
            return str.substring(0, length - ending.length) + ending;
        } else {
            return str;
        }
    };


    openInNewTab(url, page = "1", Param = "") {

        //var prdTitle = typeof this.props.match.params.title != "undefined" ? this.props.match.params.title.replace(/\+/g, " ") : "";

        //if (this.state.Isfree) {
        //    if (localStorage.getItem('user') !== null) {
        //        if (Param !== "TOC") {
        //            window['NTPT_PGEXTRA'] = 'event_type=abstract &ProductId=' + this.state.productId + ' &ProductTitle=' + prdTitle + ' &authors=' + authorFullName + ' &article_id=' + this.props.match.params.id + ' &article_title=' + this.state.ChapterTitle + ' &Country=' + this.state.countryName + '&user_id=' + localStorage.getItem('salesForceID') + ' &User=' + localStorage.getItem('user') + ' &Subscribed=' + this.state.Subscribed + '&platform=klo &useragent=' + useragent;
        //            const script = document.createElement("script");
        //            script.src = "/siqpagetag.js";
        //            script.async = true;
        //            document.body.appendChild(script);
        //        }
        //        else {
        //            window['NTPT_PGEXTRA'] = 'event_type=abstract &ProductId=' + this.state.productId + ' &ProductTitle=' + prdTitle + ' &authors=' + authorFullName + ' &article_id=' + this.props.match.params.id + ' &article_title=' + this.state.ChapterTitle + ' &Country=' + this.state.countryName + '&user_id=' + localStorage.getItem('salesForceID') + ' &User=' + localStorage.getItem('user') + ' &Subscribed=' + this.state.Subscribed + '&platform=klo &useragent=' + useragent;
        //            const script = document.createElement("script");
        //            script.src = "/siqpagetag.js";
        //            script.async = true;
        //            document.body.appendChild(script);
        //        }

        //    }
        //    else {
        //        if (Param !== "TOC") {
        //            window['NTPT_PGEXTRA'] = 'event_type=abstract &ProductId=' + this.state.productId + ' &ProductTitle=' + prdTitle + ' &authors=' + authorFullName + ' &article_id=' + this.props.match.params.id + ' &article_title=' + this.state.ChapterTitle + ' &Country=' + this.state.countryName + ' &Subscribed=' + this.state.Subscribed + '&platform=klo &useragent=' + useragent;
        //            const script = document.createElement("script");
        //            script.src = "/siqpagetag.js";
        //            script.async = true;
        //            document.body.appendChild(script);
        //        }
        //        else {
        //            window['NTPT_PGEXTRA'] = 'event_type=abstract &ProductId=' + this.state.productId + ' &ProductTitle=' + prdTitle + ' &authors=' + authorFullName + ' &article_id=' + this.props.match.params.id + ' &article_title=' + this.state.ChapterTitle + ' &Country=' + this.state.countryName + ' &Subscribed=' + this.state.Subscribed + '&platform=klo &useragent=' + useragent;
        //            const script = document.createElement("script");
        //            script.src = "/siqpagetag.js";
        //            script.async = true;
        //            document.body.appendChild(script);
        //        }
        //    }
        //}
        //else if (localStorage.getItem('user') !== null) {
        //    if (Param !== "TOC") {
        //        window['NTPT_PGEXTRA'] = 'event_type=section request&ProductId=' + this.state.productId + ' &ProductTitle=' + prdTitle + ' &authors=' + authorFullName + ' &article_id=' + this.props.match.params.id + ' &article_title=' + this.state.ChapterTitle + ' &Country=' + this.state.countryName + '&user_id=' + localStorage.getItem('salesForceID') + ' &User=' + localStorage.getItem('user') + ' &Subscribed=' + this.state.Subscribed + '&platform=klo &useragent=' + useragent;
        //        const script = document.createElement("script");
        //        script.src = "/siqpagetag.js";
        //        script.async = true;
        //        document.body.appendChild(script);
        //    }
        //    else {
        //        window['NTPT_PGEXTRA'] = 'event_type=section request&ProductId=' + this.state.productId + ' &ProductTitle=' + prdTitle + ' &authors=' + authorFullName + ' &article_id=' + this.props.match.params.id + ' &article_title=' + this.state.ChapterTitle + ' &Country=' + this.state.countryName + '&user_id=' + localStorage.getItem('salesForceID') + ' &User=' + localStorage.getItem('user') + ' &Subscribed=' + this.state.Subscribed + '&platform=klo &useragent=' + useragent;
        //        const script = document.createElement("script");
        //        script.src = "/siqpagetag.js";
        //        script.async = true;
        //        document.body.appendChild(script);
        //    }

        //}
        //else {
        //    if (Param !== "TOC") {
        //        window['NTPT_PGEXTRA'] = 'event_type=section request&ProductId=' + this.state.productId + ' &ProductTitle=' + prdTitle + ' &authors=' + authorFullName + ' &article_id=' + this.props.match.params.id + ' &article_title=' + this.state.ChapterTitle + ' &Country=' + this.state.countryName + ' &Subscribed=' + this.state.Subscribed + '&platform=klo &useragent=' + useragent;
        //        const script = document.createElement("script");
        //        script.src = "/siqpagetag.js";
        //        script.async = true;
        //        document.body.appendChild(script);
        //    }
        //    else {
        //        window['NTPT_PGEXTRA'] = 'event_type=section request&ProductId=' + this.state.productId + ' &ProductTitle=' + prdTitle + ' &authors=' + authorFullName + ' &article_id=' + this.props.match.params.id + ' &article_title=' + this.state.ChapterTitle + ' &Country=' + this.state.countryName + ' &Subscribed=' + this.state.Subscribed + '&platform=klo &useragent=' + useragent;
        //        const script = document.createElement("script");
        //        script.src = "/siqpagetag.js";
        //        script.async = true;
        //        document.body.appendChild(script);
        //    }
        //}

        ////For SiQ logging
        //var msg = {
        //    ArticleTitle: window['NTPT_PGEXTRA']
        //}
        //var Logurl = 'Product/LogData';
        //appService.submit(Logurl, msg).then(function (data) {

        //});

        //axios(url, {
        //    method: 'GET',
        //    responseType: 'blob', // important
        //}).then((response) => {
        //    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        //    window.open(url + "#page=" + page);
        //});
        window.open(url + "#page=" + page);
    }

    downloadRIS(url, productDetailId) {
        //creating an invisible element 
        var element = document.createElement('a');
        element.setAttribute('href', url);
        element.setAttribute('download', productDetailId + ".ris");
        element.setAttribute('target', '_blank');
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }

    searchAuthorContent = (e) => {
        this.state.searchAuthor = e;
        //window['SearchAuthor'] = e;
        this.setState({ redirectToSearch: true });
    }

    onDocumentLoadSuccess = ({ numPages }) => {
        this.setState({ numPages });
    }

    handleSelect() {
        window.scrollTo(0, 0);
        
    }
    handleClose() {
        this.setState({ show: false });
    }
    handleShow(e) {
        fileName = "Manuals\\" + this.state.code + "\\" + e;
        this.setState({ show: true });
    }
    handleChapterModalClose() {
        this.setState({ handleChapterModalShow: false });
    }
    handleModalClose() {
        this.setState({ handleModalShow: false });
    }

    async handleModalShow() {

        if (this.state.checked == false && this.state.checked1 == false) {
            alert('Please choose your subscription ');
        }
        else {

            const requestOptionsCountry = {

                headers: authHeader(),

            };

            const response = await fetch("https://ipapi.co/json/", requestOptionsCountry);
            const json = await response.json();
            this.setState({ currency: json.currency });

            const requestOptions = {
                method: 'POST',
                headers: authHeader(),
                body: {},
            };

            //console.log(document.location.pathname.split('/'));
            // if (this.props.match.params.id) {
            productDetailId = document.location.pathname.split("/")[3];
            // } 
            // else 
            // {           
            //params = queryString.parse(url);
            //  productDetailId = document.location.pathname.split("/")[3];
            //  }

            var self = this;
            fetch(config.apiUrl + '/Cart/AddToCart?IsProductId=true&ProductDetailId=' + productDetailId + '&OnlineThreeMonthsDelivery=' + this.state.checked + '&PrintDelivery=' + this.state.checked1 + '&currency=' + this.state.currency, requestOptions).then(function (data) {

                self.setState({ handleModalShow: true });
            });

        }

    }
    sendEmail() {
        localStorage.setItem('link', JSON.stringify(window.location.href));
        window.scrollTo(0, 0);
    }
    handleEmailModalClose() {
        this.setState({ handleEmailModalShow: false });
    }

    handleEmailModalShow() {
        this.setState({ handleEmailModalShow: true });
    }

    async handleChapterBuyModalShow() {

        const requestOptionsCountry = {
            headers: authHeader(),
        };
        const response = await fetch("https://ipapi.co/json/", requestOptionsCountry);
        const json = await response.json();
        this.setState({ currency: json.currency });

        const requestOptions = {
            method: 'POST',
            headers: authHeader(),
            body: {},
        };
        //url = this.props.location.search;
        //if (this.props.match.params.id) {
        //    productDetailId = this.props.match.params.id
        //} 
        //else 
        //{           
        //    params = queryString.parse(url);
        //    productDetailId = params.Id;
        //}
        let productDetailId = document.location.pathname.split("/")[3];

        var self = this;
        fetch(config.apiUrl + '/Cart/AddToCart?IsProductId=false&ProductDetailId=' + productDetailId + '&OnlineThreeMonthsDelivery=false&BuyChapter=true&PrintDelivery=false&currency=' + this.state.currency, requestOptions).then(function (data) {

            self.setState({ handleChapterModalShow: true });
        });


    }

    async handleChapterModalShow() {

        if (this.state.checked == false && this.state.checked1 == false) {
            alert('Please choose your subscription ');
        }
        else {

            const requestOptionsCountry = {

                headers: authHeader(),

            };

            const response = await fetch("https://ipapi.co/json/", requestOptionsCountry);
            const json = await response.json();
            this.setState({ currency: json.currency });

            const requestOptions = {
                method: 'POST',
                headers: authHeader(),
                body: {},
            };

            //console.log(document.location.pathname.split('/'));
            // if (this.props.match.params.id) {
            productDetailId = document.location.pathname.split("/")[3];
            // } 
            // else 
            // {           
            //params = queryString.parse(url);
            //  productDetailId = document.location.pathname.split("/")[3];
            //  }

            var self = this;
            fetch(config.apiUrl + '/Cart/AddToCart?IsProductId=false&ProductDetailId=' + productDetailId + '&OnlineThreeMonthsDelivery=' + this.state.checked + '&PrintDelivery=' + this.state.checked1 + '&currency=' + this.state.currency, requestOptions).then(function (data) {

                self.setState({ handleChapterModalShow: true });
            });

        }

    }
    onChange(e) {
        this.setState({ 'checked': e.target.checked });
    }

    onChange1(e) {
        this.setState({ 'checked1': e.target.checked });
    }
    componentDidMount(props) {
        productDetailId = document.location.pathname.split("/")[3];
        //Pradip Lalvani
        if (localStorage.getItem('user') !== null) {
            this.state.login = true;
        }
        else {
            this.state.login = false;
        }

        //if (this.state.login) {
        //    var pdftitle = document.getElementById('Pdftitle');
        //    pdftitle.classList.remove('Dropdownpadding');
        //    var pdflink = document.getElementById('pdflink');
        //    pdflink.classList.remove('Dropdownpadding');
        //}
        this.state.user = JSON.parse(localStorage.getItem('user')); //Pradip Lalvani
        url = this.props.location.search;

        if (this.props.match.params.id) {
            productDetailId = this.props.match.params.id
        }
        else {
            params = queryString.parse(url);
            productDetailId = params.Id;
        }


        var self = this;
        parameters = { DocId: productDetailId, user: this.state.user }; //Pradip Lalvani};
        //console.log(parameters);
        appService.getByIssueId('Product/GetChapter', parameters)
            .then(function (data) {
                if (data == "Error found") {
                    self.setState({ IsError: true });
                    //window.location = "/Maintenance";;
                }
                // console.log(data);
                else {
                  
                    self.setState({ samplePDF: data.samplePDF });
                    self.setState({ productId: data.productId });
                    self.setState({ ChapterTitle: data.chapterTitle });
                    self.setState({ countryName: data.country });
                    self.setState({ Authors: data.authors });
                    self.setState({ Contents: data.contents });
                    self.setState({ Subscribed: data.subscribed }); //Pradip Lalvani
                    self.setState({ Publishedyear: data.publicationDate });
                    self.setState({ PublicationMon: data.publicationMon });
                    if (data.reviewedDate !== 0) {
                        self.setState({ Reviewedyear: data.reviewedDate });
                        self.setState({ ReviewedMon: data.reviewedMon });
                    }
                    //self.setState({ Extract: data.extractPageNo });
                    self.setState({ ChapterId: data.id });
                    self.setState({ Imgurl: data.imageUrl });
                    self.setState({ Isfree: data.isFree });
                    self.setState({ IsSample: data.isSample });
                    self.setState({ Title: data.title });
                    self.setState({ nextid: data.nextChapterId });
                    self.setState({ previd: data.prevChapterId });
                    self.setState({ filePath: data.fileName });
                    //self.setState({ productprice: data.productPrice }); //Removed and Commented-Code Refactor -Pradip Lalvani
                    self.setState({ code: data.code });
                    self.setState({ pageRange: data.startPage + "-" + data.endPage });
                    self.setState({ mainEditors: data.editor });
                    self.setState({ TopicId: data.topicId });
                    self.setState({ TopicName: data.topic });
                    self.setState({ IsPreface: data.isPreface });
                    self.setState({ IsGeneralSection: data.isGeneralSection });
                    self.setState({ highlightText: data.highlightText });
                    //Removed and Commented-Code Refactor -Pradip Lalvani

                    //fetch("https://ipapi.co/json/")
                    //    .then(res => res.json())
                    //    .then(
                    //        (result) => {
                    //            //console.log(result)	
                    //            self.setState({ newcurrency: result.currency });
                    //            self.state.productprice.map((item) => {
                    //                // console.log(self.state.newcurrency);	
                    //                //console.log(item);	
                    //                if (self.state.newcurrency == "EURO" || self.state.newcurrency == "INR" || self.state.newcurrency == '') {
                    //                    if (item != null && item.type == "2") {
                    //                        self.setState({ OnlinePrice: item.euro });
                    //                    }
                    //                    if (item != null && item.type == "3") {
                    //                        self.setState({ printedmaterial: item.euro });
                    //                    }
                    //                    if (item != null && item.type == "1") {
                    //                        self.setState({ PdfPrice: item.euro });
                    //                    }
                    //                }
                    //                else if (self.state.newcurrency == "POUND") {
                    //                    if (item != null && item.type == "2") {
                    //                        self.setState({ OnlinePrice: item.pound });
                    //                    }
                    //                    if (item != null && item.type == "3") {
                    //                        self.setState({ printedmaterial: item.pound });
                    //                    }
                    //                    if (item != null && item.type == "1") {
                    //                        self.setState({ PdfPrice: item.pound });
                    //                    }
                    //                }
                    //                else {
                    //                    if (item != null && item.type == "2") {
                    //                        self.setState({ OnlinePrice: item.usd });
                    //                    }
                    //                    if (item != null && item.type == "3") {
                    //                        self.setState({ printedmaterial: item.usd });
                    //                    }
                    //                    if (item != null && item.type == "1") {
                    //                        self.setState({ PdfPrice: item.usd });
                    //                    }
                    //                }
                    //            }
                    //            )
                    //        });

                    appService.getAll('Product/ReadBookmarkpdf?filename=' + data.fileName + '&Type=manuals&Code=' + data.code)
                        .then(function (data) {
                            //console.log(data);
                            self.setState({ pageBookMarkList: data });
                        })

                    DipslayExtractPdf = <Document
                        file={{ url: '/api/Product/GetArticlePDF?file=Manuals\\' + data.code + "\\" + data.fileName }} renderMode="svg">
                        <Page pageNumber={1} />
                    </Document>

                    ReactGA.initialize(
                        [
                            {
                                trackingId: 'UA-2905701-8',
                                gaOptions: { name: 'tracker1' }
                            },
                            {
                                trackingId: 'UA-72849501-2',
                                gaOptions: { name: 'tracker2' }
                            }
                        ],
                        { alwaysSendToDefaultTracker: false }
                    );

                    ReactGA.pageview(window.location.pathname, ['tracker1', 'tracker2'], data.chapterTitle + " - " + data.title + " - Kluwer Law Online");
                    var metas = document.getElementsByTagName('meta');
                    for (let i = 0; i < metas.length; i++) {
                        if (metas[i].getAttribute('name') == "robots") {
                            console.log(metas[i]);
                            metas[i].remove();
                        }
                    }

                    //For undefined handle
                    //data.authors != null && data.authors != 'undefined' && data.authors.map((authoritem, index) => {

                    //    if (index == 0) {
                    //        AllauthorNames = this.decodeHtml(authoritem.firstName) + " " + this.decodeHtml(authoritem.surname)
                    //    }
                    //    else {
                    //        AllauthorNames += ", " + this.decodeHtml(authoritem.firstName) + " " + this.decodeHtml(authoritem.surname)
                    //    }

                    //})

                    var prdTitles = typeof self.props.match.params.title != "undefined" ? self.props.match.params.title.replace(/\+/g, " ") : "";
                    var eventType = "abstract";
                    if (self.state.IsPreface) {
                        eventType = "section request";
                    }
                    else if (self.state.IsGeneralSection) {
                        eventType = "";
                    }

                    if (localStorage.getItem('user') !== null) {
                        window['NTPT_PGEXTRA'] = 'event_type=' + eventType + '&investigation=table of contents&ProductId=' + data.productId + '&ProductTitle=' + prdTitles + '&authors=' + authorFullName + '&article_id=' + self.props.match.params.id + '&article_title=' + data.chapterTitle + '&Country=' + data.country + '&user_id=' + localStorage.getItem('salesForceID') + '&User=' + localStorage.getItem('user') + '&Subscribed=' + data.subscribed + '&platform=klo&useragent=' + useragent;
                        const script = document.createElement("script");
                        script.src = "/siqpagetag.js";
                        script.async = true;
                        document.body.appendChild(script);
                    }
                    else {
                        window['NTPT_PGEXTRA'] = 'event_type=' + eventType + '&investigation=table of contents&ProductId=' + data.productId + '&ProductTitle=' + prdTitles + '&authors=' + authorFullName + '&article_id=' + self.props.match.params.id + '&article_title=' + data.chapterTitle + '&Country=' + data.country + '&User= &Subscribed=' + data.subscribed + '&platform=klo&useragent=' + useragent;
                        const script = document.createElement("script");
                        script.src = "/siqpagetag.js";
                        script.async = true;
                        document.body.appendChild(script);
                    }      
                }
            })     

      
    }

    //Start:Pradip Lalvani -New
    handleValidation() {
        var self = this;
        let fields = self.state.fields;
        let errors = {};
        let formIsValid = true;

        var emailTo = this.refs["emailTo"].value;
        var emailName = this.refs["emailName"].value;

        if (emailName == "") {
            formIsValid = false;
            this.state.emailName = "* Required field";
        }
        else {
            this.state.emailName = "";
        }
        //var Body = this.refs["Body"].value;
        if (emailTo == "") {
            formIsValid = false;
            this.state.emailReciepient = "* Required field";
        }
        
        if (emailTo != "") {
            let lastAtPos = emailTo.lastIndexOf('@');
            let lastDotPos = emailTo.lastIndexOf('.');

            if (!(lastAtPos < lastDotPos && lastAtPos > 0 && emailTo.indexOf('@@') == -1 && lastDotPos > 2 && (emailTo.length - lastDotPos) > 2)) {
                formIsValid = false;
                this.state.emailReciepient = "* Please enter a valid email address";
            }
        }

        self.setState({ errors: errors });
        if (!formIsValid) {
            window.scrollTo({
                top: 200,
                behavior: 'smooth',
            });
            return false;
        }

        return true;
    }
    handleSubmit(event) {
        event.preventDefault();

        if (this.handleValidation()) {
            this.state.emailName = '';
            this.state.emailReciepient = '';
            var emailTo = this.refs["emailTo"].value;
            var Body = 'Dear ' + this.refs["emailName"].value + ",";
            var Subject = this.state.Subject;
            var isNotForLink = true;

            parameters = { To: emailTo, Body: Body, Subject: Subject, isNotForLink: isNotForLink, FileName: fileName };

            appService.getByIssueId('/Email/SendEmail', parameters)
                .then(function (data) {

                    if (data == "Success") {
                        window.location = "/ThankyouSubscription";
                    }
                });
        }
        else {
            return false;
        }
        this.setState({ show: false });
    }
    //End:Pradip Lalvani -New

    render() {
        if (this.state.redirectToLogin) {
            this.setState({ redirectToLogin: false });
            return <Redirect to={"/Login"} />
        }
        if (this.state.IsError != true) {
            const tryRequire = (path) => {
                try {
                    return require("../../../public/" + path);
                } catch (err) {
                    return null;
                }
            };

            monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
            ];
            var docID = this.state.filePath;
            docID = docID != undefined ? docID.replace(".pdf", "").replace(".rtf", "") : "";

            if (this.state.redirectToSearch) {
                this.setState({ redirectToSearch: false });
                return <Redirect to={"/SearchContent/query=?authorString=" + this.state.searchAuthor} />;
            }

            authorNames = this.state.Authors != null && this.state.Authors != 'undefined' && this.state.Authors.map((authoritem, index) => {

                return index == 0 ?
                    <span onClick={() => this.searchAuthorContent(authoritem.firstName + " " + authoritem.surname)}> <span className="HoverUnderline">{this.decodeHtml(authoritem.firstName) + " " + this.decodeHtml(authoritem.surname)}</span>
                    </span >
                    :
                    <span onClick={() => this.searchAuthorContent(authoritem.firstName + " " + authoritem.surname)}>, <span className="HoverUnderline">{this.decodeHtml(authoritem.firstName) + " " + this.decodeHtml(authoritem.surname)}</span>
                    </span >
            })

            this.state.Authors != null && this.state.Authors != 'undefined' && this.state.Authors.map((authoritem, index) => {

                if (index == 0) {
                    authorFullName = this.decodeHtml(authoritem.firstName) + " " + this.decodeHtml(authoritem.surname)
                }
                else {
                    authorFullName += ", " + this.decodeHtml(authoritem.firstName) + " " + this.decodeHtml(authoritem.surname)
                }

            })

            renderSamplePDF = this.state.samplePDF !== undefined && Object.entries(this.state.samplePDF).map((item, index) => {
                var docName = "Sample section";
                return <div className="TopicBorder" id="Samplearticle">
                    <br></br>
                    <p className="paddingL" style={{ margin: '0' }}>
                        <a className="LinkClass margintop HoverUnderline" style={{ cursor: 'pointer' }} onClick={(e) => this.handleShow(item[1].fileName)} dangerouslySetInnerHTML={{ __html: item[1].articleTitle }}></a> (PDF)
                        </p><br></br>
                </div>

            })

            var titlePlus = typeof this.state.Title == 'undefined' ? "" : this.state.Title.replace(/ /g, "+");

            meta = {
                title: this.state.ChapterTitle + " - " + this.state.Title,
                // description: "View the chapter" + this.state.ChapterTitle + " by " + authorFullName + " - " + this.props.match.params.title + "",
                canonical: window.location.href,
                //meta: {
                //    charset: "utf-8",
                //    name: {
                //        citation_title: this.state.ChapterTitle,
                //        citation_manual_title: this.state.Title,
                //        citation_authors: authorFullName,
                //        //citation_publication_date: monthNames[this.state.PublicationMon - 1] + ' ' + this.state.Publishedyear,
                //        citation_number: this.props.match.params.id,
                //        citation_productid: this.state.productId,
                //        citaion_country: this.state.countryName,
                //        title: this.state.ChapterTitle + "-" + this.props.match.params.title,
                //        citation_pdf_url: window.location.origin + 'api/Product/RenderPDF?file=Manuals\\' + this.state.code + "\\" + this.state.filePath,
                //        description: "View the chapter" + this.state.ChapterTitle + " by " + authorFullName + " - " + this.props.match.params.title + ""
                //    }
                //}
            }
        }
        return (
            this.state.IsError != true ?
            <DocumentMeta {...meta}>
                <div>
                    <div className="col-12">
                        <div className="row">
                            <div className="col-lg-9">
                                    <p className="TitlePadding"><Link to="/" className="LinkClass">Home</Link> > <Link to="/AllManuals" className="LinkClass"> All manuals</Link> > <Link to={"/Manuals/" + titlePlus + "/" + this.state.productId} className="LinkClass">{this.state.Title}</Link> > {this.state.ChapterTitle}</p>
                            </div>
                        </div>
                        <div className="row AllColPadding margintop">
                            <div className="col-lg-2 TopicPadding">
                                    <img alt={"Cover Image for " + this.state.Title} src={"/../../images/books/" + this.state.Imgurl} className="Setwdth" />
                                {(!this.state.login && !this.state.Subscribed) || (this.state.login && !this.state.Subscribed) ?
                                    <p className="center" style={{ marginTop: '2%', marginBottom: '3%', display: 'none'  }}><strong className="price">€{this.state.PdfPrice}</strong> - PDF </p>
                                    : null}
                                {(!this.state.login && !this.state.Subscribed) || (this.state.login && !this.state.Subscribed) ?
                                    <Button style={{ display: 'none' }} variant="primary" id="btnBuyChapter" onClick={this.handleChapterBuyModalShow} className="btn btn-info next Setwdth">
                                        Buy Chapter
                            </Button> : null}

                                <ChapterModal show={this.state.handleChapterModalShow} onHide={this.handleChapterModalClose}  {...this.props}
                                    size="lg"
                                    aria-labelledby="contained-modal-title-vcenter"
                                    centered>
                                    <ChapterModal.Header closeButton className="Popupcolor">
                                        <Modal.Title>Manual chapter added to cart</Modal.Title>
                                    </ChapterModal.Header>
                                    <ChapterModal.Body>
                                        <div className="row AllColPadding margintop">

                                            <div className="col-sm-3 TopicPadding">
                                                    <img alt={"Cover Image for " + this.state.Title} src={"/../../images/books/" + this.state.Imgurl} className="Setwdth" style={{ border: '1px solid #CCCCCC' }} />
                                            </div>

                                            <div className="col-sm-9 TopicPadding ">

                                                <h1 className="paddingL PublicationTitle">{this.state.ChapterTitle}
                                                    <p>

                                                        {authorFullName}

                                                    </p>
                                                    <p><span style={{ fontStyle: 'italic' }}> {this.state.Title}</span>
                                                    </p>
                                                    <span style={{ color: '#85BC20', fontSize: '18px', display: 'none'  }}>€{this.state.PdfPrice}</span> <span style={{ fontSize: '18px' }}></span>- PDF

                                            </h1>

                                            </div>
                                        </div>
                                    </ChapterModal.Body>
                                    <ChapterModal.Footer>
                                        <div className="row AllColPadding">
                                            <div className="col-sm-8 TopicPadding ">
                                                <span variant="secondary" className="Modalbutton HoverUnderline" onClick={this.handleChapterModalClose}>  Return to site </span>
                                            </div>
                                            <div className="col-sm-4 TopicPadding">
                                                <a variant="primary" className="btn btn-info next FloatSet" href="/ShoppingCart">
                                                    Go to shopping cart
                                    </a></div>
                                        </div>
                                    </ChapterModal.Footer>
                                </ChapterModal>
                            </div>
                            <div className="col-lg-7 TopicPadding" style={{ maxWidth: '56%' }}>
                                <div className="row">
                                    <div className="paddingL PublicationTitle" style={{ width: '100%' }}>

                                        {(this.state.login == true && this.state.Subscribed) || this.state.Isfree ?
                                            this.state.Isfree == true ?
                                                <div>
                                                    <div className="LinkClass HoverUnderline" style={{ position: 'absolute' }} onClick={() => this.openInNewTab('api/Product/CitationPDFURL?file=Manuals\\' + this.state.code + "\\" + this.state.filePath)}>
                                                            <img alt="Download the PDF icon" src={"/../../images/pdf-icon-with-text.svg"} />
                                                    </div>
                                                </div>
                                                :
                                                <div>
                                                    <div className="LinkClass HoverUnderline" style={{ position: 'absolute' }} onClick={() => this.openInNewTab('api/Product/CitationPDFURL?file=Manuals\\' + this.state.code + "\\" + this.state.filePath)}>
                                                            <img alt="Download the PDF icon" src={"/../../images/pdf-icon-with-text.svg"} />
                                                    </div>
                                                </div>
                                            : null}

                                        <div id="Pdftitle" style={(this.state.login == true && this.state.Subscribed) || this.state.Isfree ? setpdfpadding : null}>
                                            {
                                                (this.state.login == true && this.state.Subscribed) || this.state.Isfree ?
                                                    this.state.Isfree == true ?
                                                        <div className="LinkClass HoverUnderline" onClick={() => this.openInNewTab('api/Product/CitationPDFURL?file=Manuals\\' + this.state.code + "\\" + this.state.filePath)}>
                                                            <h1 style={{ fontSize: '20px',marginBottom:'0px' }} dangerouslySetInnerHTML={{ __html: this.state.ChapterTitle }}>
                                                                </h1>
                                                        </div>
                                                        :
                                                        <div className="LinkClass HoverUnderline" onClick={() => this.openInNewTab('api/Product/CitationPDFURL?file=Manuals\\' + this.state.code + "\\" + this.state.filePath)}>
                                                                <h1 style={{ fontSize: '20px', marginBottom: '0px' }} dangerouslySetInnerHTML={{ __html: this.state.ChapterTitle }}>
                                                                </h1>
                                                        </div>
                                                    :
                                                        <h1 style={{ fontSize: '20px', marginBottom: '0px' }} dangerouslySetInnerHTML={{ __html: this.state.ChapterTitle }}></h1>
                                            }


                                            <span className="LinkClass" style={{ display: 'block' }}>
                                                {
                                                    authorNames
                                                }
                                            </span>
                                            {
                                                this.state.Reviewedyear !== '' && this.state.Reviewedyear !== undefined ?
                                                    monthNames[this.state.PublicationMon - 1] == monthNames[this.state.ReviewedMon - 1] &&
                                                        this.state.Publishedyear == this.state.Reviewedyear ?

                                                        <span style={{ fontSize: '15px', display: 'block' }}>{monthNames[this.state.PublicationMon - 1]} {this.state.Publishedyear}</span>
                                                        :
                                                        <span style={{ fontSize: '15px', display: 'block' }}>Published {monthNames[this.state.PublicationMon - 1]} {this.state.Publishedyear}, Reviewed {monthNames[this.state.ReviewedMon - 1]} {this.state.Reviewedyear}</span>
                                                    :
                                                    <span style={{ fontSize: '15px', display: 'block' }}>{monthNames[this.state.PublicationMon - 1]} {this.state.Publishedyear}</span>
                                            }
                                        </div>

                                        <p className="margintop">
                                            <span className="LinkClass margintop" style={{ fontStyle: 'italic' }}>
                                                <Link onClick={this.handleSelect} to={"/Manuals/" + titlePlus + "/" + this.state.productId} dangerouslySetInnerHTML={{ __html: this.state.Title }} className="ArticleChapter"></Link></span>
                                            <br></br>
                                        </p>

                                        <CopyToClipboard text={(authorFullName !== null ? authorFullName : "[null]") + ", '" + this.state.ChapterTitle + "', (" + this.state.Publishedyear + ")" + ", pp." + this.state.pageRange + ", in " + this.state.mainEditors + ", " + this.state.Title + ", (Kluwer Law International BV, Netherlands), " + document.location.href}
                                            onCopy={() => this.setState({ copied: true })}>
                                            <button className="btn BorderBtn">
                                                {!this.state.copied ? "Copy citation to clipboard" : "Citation copied"}
                                            </button>
                                            </CopyToClipboard> <button onClick={() => this.downloadRIS('api/Product/GetProductDetailsByDocId?docId=' + productDetailId, productDetailId)} className="btn BorderBtn">Export citation to RIS</button>
                                        <br></br>
                                        <br></br>
                                        {(this.state.highlightText != null) ?
                                        <div>
                                            <h2><p className="Abstract SetPaddingforP">Highlights</p></h2>
                                                    <p className="journalbody" style={{ fontSize: '16px', textAlign: 'justify' }} dangerouslySetInnerHTML={{ __html: this.state.highlightText }}>

                                            </p>
                                        </div>
                                        : null}
                                        <h2><p className="Abstract">
                                            Contents</p></h2>
                                        <hr className="HrCSS"></hr>
                                        {(this.state.login == true && this.state.Subscribed) || this.state.Isfree ?
                                            this.state.pageBookMarkList.map((item, key) =>
                                                <div className={item.className} style={sectionStyle}>
                                                    <div className="pdffont" style={item.className == '' ? paddingsetforwhite : paddingsetforgrey}>
                                                        <span className="LinkClass HoverUnderline" TOCdata-tooltip={item.bookMarkName} onClick={() => this.openInNewTab('api/Product/CitationPDFURL?file=Manuals\\' + this.state.code + "\\" + this.state.filePath, item.page,"TOC")}>
                                                            {item.bookMarkName.length < 68 ? item.bookMarkName : this.stingBreakLine(item.bookMarkName, 68, "..")}
                                                        </span>
                                                        <div className="Fright"> pp {item.pageRange} </div>  {/*DIV tag cannot come as descendant of P tag*/}
                                                    </div>
                                                </div>
                                            )
                                            :
                                            this.state.pageBookMarkList.map((item, key) =>
                                                <div className={item.className} style={sectionStyle}>
                                                    <div className="pdffont" style={item.className == '' ? paddingsetforwhite : paddingsetforgrey}>
                                                        <span TOCdata-tooltip={item.bookMarkName}>
                                                            {item.bookMarkName.length < 68 ? item.bookMarkName : this.stingBreakLine(item.bookMarkName, 68, "..")}
                                                        </span>
                                                        <div className="Fright"> pp {item.pageRange} </div>  {/*DIV tag cannot come as descendant of P tag*/}
                                                    </div>
                                                </div>
                                            )}
                                        <hr className="HrCSS"></hr>
                                        <br></br>
                                        {this.state.filePath !== null && this.state.filePath !== '' && this.state.filePath !== undefined 
                                            && this.state.code !== null && this.state.code !== undefined ?
                                           
                                            <h2>
                                                <p className="Abstract"> Extract </p>
                                                <div>
                                                        {DipslayExtractPdf}
                                                </div>
                                                </h2>
                                                
                                            :
                                            null}
                                        {
                                            !this.state.Subscribed && !this.state.Isfree ?
                                                <p style={{ display: 'none' }}>To read more, you can <span style={{ cursor: 'pointer' }} className="LinkClass HoverUnderline" onClick={this.handleChapterBuyModalShow}>buy this chapter</span>.
                                        </p>
                                                :
                                                null
                                        }

                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                {(!this.state.login && !this.state.Subscribed) || (this.state.login && !this.state.Subscribed) ? /*Pradip Lalvani*/
                                    <div>
                                        <div className="TopicBorder BGGrey" id="Subcribeto" style={{ borderTop: '2px solid #CCCCCC', paddingBottom: '3%', paddingTop: '3%', fontSize: '18px' }}>
                                            <span className="paddingL fontbold margintop SetPaddingforP"> Subscribe to this manual </span>
                                        </div>
                                        <div className="TopicBorder" id="Pricemenu">
                                            <p className="paddingL fontbold" style={{lineHeight: '3', marginBottom: '3%'}}>Interested in a subscription?
                                                    <Link to="/ContactSales" variant="secondary" style={{ marginTop: '3%', textAlign: 'center' }} className="Modalbutton Setwdth HoverUnderline">  <strong> Contact our sales team</strong> </Link>
                                            </p>
                                        </div>
                                        {
                                            this.state.samplePDF !== undefined && this.state.samplePDF.length > 0 ?
                                                <div>
                                                    <div className="TopicBorder BGGrey" id="Takealook" style={{ paddingBottom: '3%', paddingTop: '3%', fontSize: '18px' }}>
                                                        <span className="paddingL fontbold margintop">Sample content</span>
                                                    </div>

                                                    {renderSamplePDF}
                                                </div>
                                                :
                                                null
                                        }
                                    </div>
                                    : null}
                                <Modal show={this.state.show} onHide={this.handleClose}  {...this.props}
                                    size="md"
                                    aria-labelledby="contained-modal-title-vcenter"
                                    centered>
                                    <Modal.Header closeButton className="Popupcolor">
                                        <Modal.Title>Sample content</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <div className="col-8">
                                            <label htmlFor="Name">Name</label>
                                            <input type="text" className="form-control form-control-sm rounded-0" ref="emailName" placeholder="Enter your name" id="Name" />
                                            <span className="error">{this.state.emailName}</span>
                                        </div>
                                        <br></br>
                                        <div className="col-8">
                                            <label htmlFor="Email">Email</label>
                                            <input type="text" className="form-control form-control-sm rounded-0" ref="emailTo" placeholder="Enter your email" id="Email" />
                                            <span className="error">{this.state.emailReciepient}</span>
                                        </div>
                                        <br></br>
                                        <div className="col-8">
                                            <a href="http://www.kluwerlaw.com/terms-and-conditions/" target="_blank">Terms and Conditions</a>
                                        </div>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <div className="row">
                                            <div className="col" style={{ paddingLeft: '6%' }}>
                                                <span variant="secondary" className="Modalbutton HoverUnderline" onClick={this.handleClose}>  Return to site </span>
                                            </div>
                                            <div className="col TopicPadding">
                                                <button type="button" className="btn btn-info next rounded-0" onClick={this.handleSubmit}>Submit</button>
                                            </div>
                                        </div>
                                    </Modal.Footer>
                                </Modal>
                                <div className="TopicBorder BGGrey" style={{ paddingBottom: '3%', paddingTop: '3%', fontSize: '18px' }}>
                                    <span className="paddingL fontbold margintop SetPaddingforP">Practice areas</span>
                                </div>
                                <div className="TopicBorder">
                                    <br></br>
                                    {this.state.TopicName !== undefined ?
                                        <Link to={"/PracticeArea?Id=" + this.state.TopicId + "&name=" + this.state.TopicName.replace(/ /g, "+")} onClick={this.handleSelect} className="paddingL LinkClass margintop" style={this.state.TopicName.length > 33 ? Displaystyle : null}>{this.state.TopicName} </Link>
                                        :
                                        null
                                    }

                                    <br></br>
                                    <br></br>
                                </div>
                                <div className="TopicBorder BGGrey" style={{ paddingBottom: '3%', paddingTop: '3%', fontSize: '18px' }}>
                                    <span className="paddingL fontbold margintop SetPaddingforP"> Share </span>
                                </div>
                                <div className="TopicBorder">
                                    <br></br>
                                    <CopyToClipboard text={document.location.href}>
                                        <span data-tooltip="Share on Linkedin" className="RSSCard Shareicon-margin" >
                                                <a href={"https://www.linkedin.com/shareArticle?mini=true&url=" + window.location.href + "&title=&summary=&source="}
                                                    target="_blank"
                                                    title="Share on Linkedin">
                                                <i class="fa fa-linkedin shareicons colPadding btn-fa" aria-hidden="true"></i></a>
                                        </span>
                                    </CopyToClipboard>
                                    <CopyToClipboard text={document.location.href}>
                                        <span data-tooltip="Share on Facebook" className="RSSCard Shareicon-margin" >
                                                <a href={"https://www.facebook.com/sharer/sharer.php?u=" + window.location.href}
                                                    target="_blank" title="Share on Facebook">
                                                <i class="fa fa-facebook shareicon-facebook colPadding btn-fa" aria-hidden="true"></i></a>
                                        </span>
                                    </CopyToClipboard>
                                    {/* <span onClick={this.handleEmailModalShow} className="RSSCard Shareicon-margin" data-tooltip="Share by Email">
                                        <i class="fa fa-envelope shareicons colPadding btn-fa" aria-hidden="true"></i>
                                    </span> */}
                                    <br></br>
                                    <br></br>
                                </div>
                                <EmailModal show={this.state.handleEmailModalShow} onHide={this.handleEmailModalClose}  {...this.props}
                                    size="lg"
                                    aria-labelledby="contained-modal-title-vcenter"
                                    centered>
                                    <EmailModal.Header closeButton className="Popupcolor">
                                        <Modal.Title>
                                            Share by email
                                            </Modal.Title>
                                    </EmailModal.Header>
                                    <EmailModal.Body>
                                        <div>
                                            <div className="row mt-3 AllColPadding">
                                                <div className="col-lg-6 TopicPadding">
                                                    <label for="To">To</label>
                                                    <input type='email' id="email" name="email" ref="email" className="form-control form-control-sm rounded-0"
                                                        placeholder="Enter your email address(es); separated by semi-colon" />
                                                    <span className="error">{this.state.emailRec}</span>
                                                </div>
                                            </div>
                                            <div className="row mt-3 AllColPadding">
                                                <div className="col-lg-6 TopicPadding">
                                                    <label for="SubjectTitle">Subject</label>
                                                    <input type="text" ref="SubjectTitle" className="form-control form-control-sm rounded-0" placeholder={this.state.Title} id="SubjectTitle" name="SubjectTitle" />
                                                </div>
                                            </div>
                                            <div className="row mt-3 AllColPadding">
                                                <div className="col-lg-6 TopicPadding">
                                                    <label for="URL" style={{ fontSize: '12px' }}>{window.location.href}</label>
                                                    <textarea
                                                        className="form-control"
                                                        id="addInfo"
                                                        name="addInfo"
                                                        rows="3" placeholder="Enter message" ref="AddInfo"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </EmailModal.Body>
                                    <EmailModal.Footer>
                                        <div className="row AllColPadding">
                                            <div className="col-sm-8 TopicPadding ">
                                                <span variant="secondary" className="Modalbutton HoverUnderline" onClick={this.handleEmailModalClose}>  Return to site </span>
                                            </div>
                                            <div className="col-sm-4 TopicPadding">
                                                <button variant="primary" className="btn btn-info next FloatSet" onClick={this.sendShareByEmail}>
                                                    Submit
                                    </button></div>
                                        </div>
                                    </EmailModal.Footer>
                                </EmailModal>

                                <div className="TopicBorder BGGrey" style={{ paddingBottom: '3%', paddingTop: '3%', fontSize: '18px' }}>
                                    <span className="paddingL SetPaddingforP"> Stay up to date </span>
                                </div>
                                <div className="TopicBorder" style={{ paddingBottom: '3%' }}>
                                    <br></br>
                                        <a className="LinkClass RSSCard Shareicon-margin" style={{ cursor: 'pointer' }} href={'feeds/' + this.state.code} target="_blank" title="Open RSS feed" data-tooltip="RSS feed for this title">
                                        <i class="fa fa-rss shareicon-ETOC colPadding btn-fa" aria-hidden="true"></i>                                       
                                    </a>
                                        <Link to="/Etoc" onClick={this.handleSelect} className="RSSCard Shareicon-margin" data-tooltip="Table of contents alert for this title"
                                            title="Table of contents alert for this title">
                                            <i class="fa fa-clock-o shareicon-ETOC colPadding btn-fa" aria-hidden="true"></i>
                                        </Link>
                                    <br></br>
                                    <span style={{ fontSize: '11px', color: '#757575', marginLeft: '7%' }}>RSS</span>
                                    <span style={{ fontSize: '11px', color: '#757575', marginLeft: '13%' }}>ETOC</span>
                                    <br></br>
                                    </div>
                                    <EmailModal show={this.state.handleEtocModalShow} onHide={this.handleEtocModalClose}  {...this.props}
                                        size="lg"
                                        aria-labelledby="contained-modal-title-vcenter"
                                        centered>
                                        <EmailModal.Header closeButton className="Popupcolor">
                                            <Modal.Title>
                                                Table of Contents alert (ETOC)
                                            </Modal.Title>
                                        </EmailModal.Header>
                                        <EmailModal.Body>
                                            <div>
                                                <div className="row mt-6 AllColPadding">
                                                    <div className="col-lg-6 TopicPadding">
                                                        <label>Sign up for ETOC alerts to receive an e-mail informing you when new content for Kluwer Law Online prodcuts is available online. Login or create an account and select the title(s) you wish to subscribe to.</label>

                                                    </div>
                                                </div>

                                            </div>
                                        </EmailModal.Body>
                                        <EmailModal.Footer>
                                            <div className="row AllColPadding">

                                                <div className="col-sm-4 TopicPadding">

                                                    <span variant="secondary" className="Modalbutton HoverUnderline" onClick={this.logoutsession}>  Login/Create Account </span>
                                                </div>
                                                <div className="col-sm-8 TopicPadding ">
                                                    <span variant="secondary" className="Modalbutton HoverUnderline" onClick={this.handleEtocModalClose}>  Return to site </span>
                                                </div>
                                            </div>
                                        </EmailModal.Footer>
                                    </EmailModal>
                            </div>
                        </div>
                        <div className="White">
                        </div>
                    </div>
                </div >
                </DocumentMeta >
                :
                <Maintenance />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Manuals/ManualChapter.jsx